import React from 'react';
import styled from '@emotion/styled';
import { PODCAST_AD_DEFINITIONS } from 'client/screens/AdsByAnchorScreen/constants';
import {
  COLOR_GREEN,
  BREAKPOINT_SMALL,
} from 'client/components/MarketingPagesShared/styles';

const Section = styled.section`
  color: #97e0ce;
  background: ${COLOR_GREEN};
`;

const Container = styled.div`
  max-width: 880px;
  margin: 0 auto;
  padding: 132px 24px;
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    padding: 100px 24px;
  }
`;

const Heading = styled.h2`
  margin: 0 0 50px;
  font-weight: 900;
  font-size: 3.6rem;
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    font-size: 2.8rem;
  }
`;

const DefinitionList = styled.dl`
  width: 100%;
  max-width: 790px;
  font-size: 1.6rem;
`;

const DefinitionContainer = styled.div`
  margin-bottom: 30px;
  dt,
  dd {
    display: inline;
    line-height: 3rem;
  }
`;

export function Glossary() {
  return (
    <Section>
      <Container>
        <Heading>Podcast Ads Glossary:</Heading>
        <DefinitionList>
          {PODCAST_AD_DEFINITIONS.map(({ term, definition }) => {
            return (
              <DefinitionContainer key={term}>
                <dt>{term}</dt>
                <dd>
                  {` - `} {definition}
                </dd>
              </DefinitionContainer>
            );
          })}
        </DefinitionList>
      </Container>
    </Section>
  );
}
